<template lang="pug">
    multiselect-form(
        ref="categorySelector"
        :value="value",
        name="faqGuidelineCategorySelector",
        :options="categories",
        placeholder="Type to search or create a category",
        item-placeholder="Add this as a new category",
        @create="submit",
        @add-item="onAddedItem",
        @show-form="onShowForm",
        @hide-form="onHideForm",
        @input="onInput",
        title="Category",
        loader-name="save-faq-guideline-category",
        :close-on-select="true",
        :hide-selected="false",
        :multiple="false",
        form-title="Create new category",
        :disabled="disabled"
    )
        template(slot="body")
            form(id="faqGuidelineCategoryForm")
                fieldset(:disabled="loading")
                    div.md-form-group
                        input.md-input(
                            placeholder="e.g Operations",
                            id="faq-guideline-category-name"
                            type="text",
                            v-model="category.name",
                            required
                        )
                        label Name
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import multiselectForm from '../inventory/item/multiselect-form.vue';

export default {
    components: { multiselectForm },

    props: {
        value: {
            type: null,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            category: this.newCategory(),
        };
    },

    computed: {
        ...mapGetters('faqGuideline', { categories: 'faqGuidelineCategories' }),

        loading() {
            return this.onLoading('save-faq-guideline-category');
        },
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('faqGuideline', ['createFaqGuidelineCategory']),

        newCategory() {
            return {
                id: null,
                name: null,
            };
        },

        submit() {
            if (!this.validateForm('faqGuidelineCategoryForm')) return;

            this.createFaqGuidelineCategory(this.category)
                .then(category => {
                    this.$emit('item-created', category);
                })
                .catch(err => {
                    this.showApiError(err);
                });
        },

        focusOnForm() {
            setTimeout(() => {
                document.getElementById('faq-guideline-category-name').focus();
            }, 100);
        },

        onAddedItem(name) {
            this.category.name = name;
        },

        onShowForm() {
            this.focusOnForm();
        },

        onHideForm() {
            this.category = this.newCategory();
        },

        registerEvent() {
            this.$on('item-created', item => {
                this.$refs.categorySelector.$emit('item-created', item);
            });
        },

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/faq_guideline/faq-guideline-category-selector.vue